import { render, staticRenderFns } from "./AirLeeChooseClinicHQ.vue?vue&type=template&id=0b4cac5d&scoped=true&"
import script from "./AirLeeChooseClinicHQ.vue?vue&type=script&lang=js&"
export * from "./AirLeeChooseClinicHQ.vue?vue&type=script&lang=js&"
import style0 from "./AirLeeChooseClinicHQ.vue?vue&type=style&index=0&id=0b4cac5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4cac5d",
  null
  
)

export default component.exports